import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-start-reservation',
    templateUrl: './start-reservation.component.html',
    styleUrls: ['./start-reservation.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class StartReservationComponent {}
